import React, { useEffect } from 'react'

const MagicZoom = ({
    children,
    magicZoomId = '',
    largeImageUrl,
    smallImageUrl,
    zoomOnClick,
    className
}) => {
    useEffect(() => {
        window?.MagicZoom?.update(magicZoomId, largeImageUrl, smallImageUrl)
    }, [largeImageUrl])

    useEffect(() => {
        const anchor = document.getElementById(magicZoomId)
        if (!anchor) return

        const observer = new MutationObserver(() => {
            if (anchor.getAttribute('target') === '_blank') {
                anchor.removeAttribute('target')
            }
        })

        observer.observe(anchor, { attributes: true, attributeFilter: ['target'] })

        return () => observer.disconnect()
    }, [magicZoomId])

    return largeImageUrl && smallImageUrl ? (
        <a
            id={magicZoomId}
            href={largeImageUrl}
            onClick={(e) => e.preventDefault()}
            className={`MagicZoom ${className || ''}`}
            data-options={`autostart: false; zoomPosition: inner; expand: off; hint: off; ${
                zoomOnClick ? 'zoomOn: click' : ''
            }`}
        >
            {children}
        </a>
    ) : (
        { children }
    )
}

export default MagicZoom
